import {animate, state, style, transition, trigger} from "@angular/animations";

export const RP_MODAL_ANIMATION = trigger('rpModal', [
  state('open', style({
    transform: 'translateX(100%)'
  })),
  state('close', style({
    transform: 'translateX(0)'
  })),
  transition('open => close', [
    animate('0.2s ease')
  ]),
  transition('close => open', [
    animate('1s ease')
  ])
])
